//#region src/punchh_api_server.ts
let PunchhApiServer = /* @__PURE__ */ function(PunchhApiServer) {
	PunchhApiServer[PunchhApiServer["Punchh"] = 1] = "Punchh";
	PunchhApiServer[PunchhApiServer["UsWestPunchh"] = 2] = "UsWestPunchh";
	PunchhApiServer[PunchhApiServer["PosDQPunchh"] = 3] = "PosDQPunchh";
	return PunchhApiServer;
}({});
//#endregion
export { PunchhApiServer };

//# sourceMappingURL=punchh_api_server.js.map